var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { attrs: { id: "banner" } }),
      _vm._v(" "),
      _vm._l(_vm.options, function(category, type) {
        return _c(
          "div",
          [
            _c("div", { staticClass: "row head" }, [
              _c("div", { staticClass: "col col-100" }, [
                _vm._v("Beschikbare " + _vm._s(type) + "s")
              ])
            ]),
            _vm._v(" "),
            _vm._l(category, function(option, index) {
              return _c("div", [
                _c(
                  "div",
                  {
                    staticClass: "row row-single setting subscription",
                    on: {
                      click: function($event) {
                        return _vm.switch_subscription(option, type)
                      }
                    }
                  },
                  [
                    _c("div", {
                      staticClass: "avatar",
                      class: "avatar--" + option.icon
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "account-info" }, [
                      _c("div", { staticClass: "table" }, [
                        _c("div", { staticClass: "cell" }, [
                          _c("div", { staticClass: "account-info__title" }, [
                            _vm._v(_vm._s(option.name))
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "account-info__subtitle" }, [
                            _c("p", [_vm._v(_vm._s(option.description))]),
                            _vm._v(" "),
                            _c("p", [
                              _c("em", [_vm._v(_vm._s(option.salesLine1))])
                            ]),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticClass: "account-info__subtitle--large" },
                              [
                                _vm._v(
                                  _vm._s(option.price) + " exclusief btw p/m"
                                )
                              ]
                            )
                          ])
                        ])
                      ])
                    ])
                  ]
                )
              ])
            })
          ],
          2
        )
      }),
      _vm._v(" "),
      _vm.$root.app.platform == "ios"
        ? _c("div", { staticClass: "row spacer" }, [_vm._v(" ")])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3472d205", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3472d205","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/subscriptions/Options.vue
// module id = null
// module chunks = 